import { Insurer, Selection } from '../enums'
import type { Discount } from './Discounts'
import type { Error } from './Error'
import type { StepBase } from './StepBase'

export type MeetingRecord = {
  paramsId: number
  irregularities?: string //ContractRequirementDisagreements
  reasons?: string //ContentNegotiation
  startType?: number //ContractAcceptationType
  paymentEnabled: boolean
  signatureEnabled: boolean
  digitalSignatureEnabled: boolean
  brokerNumbers: Acquirer[] //Acquirers
  discounts?: Discount[]
  previousContractNumber?: string
  contractReplacementOverpaymentTypeId?: number
  contractReplacementOverpaymentAccount?: string
  errors?: Error[]
  createContractAsUserId: string
  placeOfContract?: string //agreementPlace
  firstPaymentTypeBankTransferEnabled?: boolean
  firstPaymentTypePaymentGateEnabled?: boolean
  firstPaymentType?: number
  digitalSignatureType?: number
  allowedDigitalSignatureTypes?: number[]
  additionalClientRequirements?: string // Bližší specifikace požadavků a potřeb klienta (Essox, OK Apps)
} & StepBase

export interface Acquirer {
  id: number
  acquisitionNumber: string
  typeId: number
  percentage: number
}

export const getDigitalSignatureInstructions = (
  insurer: number,
  digitalSignatureTypeId?: number,
) => {
  const instructions: string[] = []

  if (insurer == Insurer.Kooperativa) {
    if (digitalSignatureTypeId == Selection.DigitalSignatureTypeLocal) {
      instructions.push('Získatel a po něm pojistník podepíše návrh smlouvy.')
      instructions.push('Pojišťovna zašle podepsanou smlouvu pojistníkovi emailem.')
    }

    if (digitalSignatureTypeId == Selection.DigitalSignatureTypeRemote) {
      instructions.push('Získatel podepíše návrh smlouvy.')
      instructions.push('Pojišťovna zašle pojistníkovi email s odkazem pro podepsání.')
      instructions.push(
        'Upozorněte pojistníka, že odkaz je třeba otevírat pouze na zařízení s dotykovou obrazovkou.',
      )
      instructions.push('Pojistník podepíše návrh smlouvy.')
      instructions.push('Pojišťovna zašle podepsanou smlouvu pojistníkovi emailem.')
    }
  }
  if (insurer == Insurer.CPP) {
    if (digitalSignatureTypeId == Selection.DigitalSignatureTypeLocal) {
      instructions.push('Pojistník podepíše návrh smlouvy.')
      instructions.push('Pojišťovna zašle podepsanou smlouvu pojistníkovi emailem.')
    }

    if (digitalSignatureTypeId == Selection.DigitalSignatureTypeRemote) {
      instructions.push(
        'Pojišťovna zašle pojistníkovi email s odkazem pro podepsání a SMS s ověřovacím kódem.',
      )
      instructions.push('Pojistník podepíše návrh smlouvy.')
      instructions.push('Pojišťovna zašle podepsanou smlouvu pojistníkovi emailem.')
    }
  }
  if (insurer == Insurer.GeneraliCeskaPojistovna) {
    if (digitalSignatureTypeId == Selection.DigitalSignatureTypeLocal) {
      instructions.push('Získatel se přihlásí do podepisovací aplikace a podepíše návrh smlouvy.')
      instructions.push('Pokud je k dispozici více variant podpisu, může je získatel pojistníkovi nabídnout.')
      instructions.push('Získatel ukáže pojistníkovi podepisované dokumenty a potvrdí jejich přečtení.')
      instructions.push('Podle varianty podpisu pojistník ve spolupráci se získatelem podepíše návrh smlouvy nebo potvrdí kód zaslaný SMS.')
      instructions.push('Pojišťovna zašle podepsanou smlouvu pojistníkovi emailem.')
    }

    if (digitalSignatureTypeId == Selection.DigitalSignatureTypeRemote) {
      instructions.push('Získatel se přihlásí do podepisovací aplikace a podepíše návrh smlouvy.')
      instructions.push('Pojišťovna zašle pojistníkovi email s odkazem pro podepsání.')
      instructions.push('Po vstupu do podepisovací aplikace se pojistník musí nejprve ověřit pomocí SMS kódu.')
      instructions.push('Po té potvrdí přečtění podepisované smlouvy a vše potvrdí ověřovacím kódem zaslaným přes SMS.')
      instructions.push('Pojišťovna zašle podepsanou smlouvu pojistníkovi emailem.')
    }
  }

  if (insurer == Insurer.Csob) {
    if (digitalSignatureTypeId == Selection.DigitalSignatureTypeLocal) {
      instructions.push('Získatel a po něm pojistník podepíše předsmluvní dokument.')
    }
  }

  return instructions
}

export const getDigitalSignatureSecondInstructions = (
  insurer: number,
  digitalSignatureTypeId?: number,
) => {
  const instructions: string[] = []

  if (insurer == Insurer.Csob) {
    if (digitalSignatureTypeId == Selection.DigitalSignatureTypeLocal) {
      instructions.push('Získatel a po něm pojistník podepíše návrh smlouvy.')
      instructions.push('Pojišťovna zašle podepsanou smlouvu pojistníkovi emailem.')
    }
  }

  return instructions
}
